import type { TOC } from '@ember/component/template-only'
import { type AwardsEarnedMathsRoute } from 'teacher-ui-client/reporting/ui-scope/maths/awards-earned/route'
import { ReportingTeacherUiHeader } from 'teacher-ui-client/components/reporting/teacher-ui-header'
import { ReportingDetailedControls } from 'teacher-ui-client/components/reporting/detailed-controls'
import { array } from '@ember/helper'
import { ExportType } from 'teacher-ui-client/components/reporting/export-select'
import { ReportingNoDataMessageIf } from 'teacher-ui-client/components/reporting/no-data-message-if'
import { not } from 'ember-truth-helpers'
import PhosphorIcon from 'teacher-ui-client/components/phosphor-icon'
import { Tooltip } from 'teacher-ui-client/components/tooltip'
import { AwardsEarnedCertificatesHistory } from 'teacher-ui-client/components/giraffe/charts/awards-earned/certificates/history'
import { AwardsEarnedCertificatesTotals } from 'teacher-ui-client/components/giraffe/charts/awards-earned/certificates/totals'
import { fullGradeName } from 'teacher-ui-client/helpers/full-grade-name'
import { camelize } from '@ember/string'
import IsSubco from 'teacher-ui-client/helpers/is-subco'
import RouteTemplate from 'ember-route-template'
import { t } from 'ember-intl'
import { concat } from '@ember/helper'

interface Signature {
  Args: {
    model: ModelFor<AwardsEarnedMathsRoute>
  }
}
export const ReportingUiScopeMathsAwardsEarnedPage: TOC<Signature> = <template>
  <ReportingTeacherUiHeader @title={{t "reporting.pageTitles.awardsEarned.maths"}} />
  <ReportingDetailedControls
    @students={{@model.scopedStudents}}
    @exportOptions={{array ExportType.print}}
    @isDataPresent={{Boolean @model.awardsEarnedTotals}}
    @showScopePicker={{true}}
    @showDatePicker={{true}}
    @studentRouteName="reporting.ui-scope.maths.student-summary"
  />
  <ReportingNoDataMessageIf @on={{not @model.awardsEarnedTotals}}>
    {{#each @model.awardsEarnedTotals as |gradeData index|}}
      <div
        class="border-dusty-black-50 shadow-dusty-black-100 print:border-dusty-black-200 relative my-10 h-76 rounded-md border bg-white shadow-md print:rounded-none print:shadow-none"
      >
        <AwardsEarnedCertificatesTotals
          data-test-awards-earned-totals={{index}}
          @data={{gradeData}}
          @product={{@model.product}}
          @title={{t "reporting.chartTitles.awardsEarnedTotals.maths"}}
          @summaryTitle={{t (concat "reporting.summaryTitles.awardsEarnedTotals." (camelize @model.uiScope.scope))}}
          @grade={{fullGradeName gradeData.grade_position}}
          @yAxisTitle={{t "reporting.chartTitles.awardsEarnedTotals.maths"}}
        />
        <span class="absolute top-0 right-1 print:hidden">
          <PhosphorIcon @icon="phosphor-info-fill" class="text-dusty-black-500 h-4 w-4 cursor-pointer" />
          <Tooltip @text={{t "reporting.tooltips.awardsEarnedTotals.maths" htmlSafe=true}} />
        </span>
      </div>
    {{/each}}

    {{#if @model.awardsEarnedHistory}}
      <AwardsEarnedCertificatesHistory
        @certificatesHistoryData={{@model.awardsEarnedHistory}}
        @students={{@model.scopedStudents}}
        @subco={{(IsSubco)}}
        @product={{@model.product}}
        @uiScope={{@model.uiScope.scope}}
        @studentRouteName="reporting.ui-scope.maths.student-summary"
        @tooltip={{t "reporting.tooltips.awardsEarnedHistory.maths" htmlSafe=true}}
      />
    {{/if}}
  </ReportingNoDataMessageIf>
</template>

export default RouteTemplate(ReportingUiScopeMathsAwardsEarnedPage)
